import React from "react";
import { Space, Text } from "@mantine/core";
import SurveyForm from "../components/SurveyForm";
import PageHeading from "../../../themes/components/PageHeading";
import NotFound from "../../../common/pages/NotFound";
import { AccessPermissionContext } from "../../../providers/AccessPermissionsProvider";

const SurveyCreatePage: React.FC = () => {
  const { hasPermissions } = React.useContext(AccessPermissionContext);

  if (!hasPermissions) {
    return <NotFound />;
  }

  return (
    <>
      <div style={{ padding: "26px 40px" }}>
        <PageHeading title="Create Survey">
          <Text>Survey Details</Text>
        </PageHeading>
      </div>

      <Space h="xl" />
      <SurveyForm />
    </>
  );
};

export default SurveyCreatePage;
